module.exports = __webpack_public_path__ + "img/Mode_Selector_KingRest.252c0c7f.png";